import { c as _c } from "react/compiler-runtime";
import { getPrices, getPriceVariant, isPriceRange } from '@libs/algolia';
import { formatPrice, ProductPriceDisplay, type ProductPriceDisplayProps } from '@libs/common-next';
import type { PriceData } from '@libs/common-types';
type ProductPriceProps = {
  price: PriceData;
};
export function ProductPrice(t0) {
  const $ = _c(11);
  const {
    price
  } = t0;
  let isRange;
  let t1;
  if ($[0] !== price) {
    isRange = isPriceRange(price);
    t1 = getPrices(price, isRange).map(formatPrice);
    $[0] = price;
    $[1] = isRange;
    $[2] = t1;
  } else {
    isRange = $[1];
    t1 = $[2];
  }
  const values = t1;
  let t2;
  if ($[3] !== price) {
    t2 = getPriceVariant(price);
    $[3] = price;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isOnSale = t2 === "disabled";
  const [currentPrice, secondPrice] = values;
  if (!currentPrice) {
    return null;
  }
  const isSaleRange = isOnSale && values.length === 4;
  let t3;
  if ($[5] !== currentPrice || $[6] !== isOnSale || $[7] !== isRange || $[8] !== isSaleRange || $[9] !== secondPrice) {
    const displayProps = isRange && secondPrice && (!isOnSale || isSaleRange) ? {
      className: "header-search__price",
      fromPrice: currentPrice,
      isOnSale: isSaleRange,
      toPrice: secondPrice,
      type: "range"
    } : {
      className: "header-search__price",
      originalPrice: isOnSale ? secondPrice : undefined,
      price: currentPrice,
      type: "default"
    };
    t3 = <ProductPriceDisplay {...displayProps} />;
    $[5] = currentPrice;
    $[6] = isOnSale;
    $[7] = isRange;
    $[8] = isSaleRange;
    $[9] = secondPrice;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}